import styled from "@emotion/styled";

export const SidebarSectionEmpty = styled.div`
  display: flex;
  width: 192px;
  padding: 10px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
`;
